import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import Users from "./Users/Users";
const AdminDashboard = () => {
  return (
    <>
      <section className="dashboard">
        <div className="dashboard__header">
          <h2>Admin Dashboard</h2>
        </div>
        <div className="dashboard__main">
          <div className="dashboard__main__left">
            <nav>
              <ul>
                <li>
                  <Link to="/admin/add-product">User List</Link>
                </li>
                <li>
                  <Link to="/admin/add-product">All Product</Link>
                </li>
                <li>
                  <Link to="/admin/products">All Products</Link>
                </li>
              </ul>
            </nav>
          </div>
          <div className="dashboard__main__right">
            <Container fluid>

              <Row>
                <Col lg={12} md={12} sm={12} xs={12}>
                  <Users />
                </Col>
              </Row>
            </Container>
          </div>
        </div>

      </section>
    </>
  );
}

export default AdminDashboard;